import { render, staticRenderFns } from "./prod_blacklist.vue?vue&type=template&id=53bc3d94"
import script from "./prod_blacklist.vue?vue&type=script&lang=js"
export * from "./prod_blacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports